export const linePageStyles = (theme, primaryColor) => ({
  linePageGiftInfo: {
    backgroundImage: `linear-gradient(to right, ${primaryColor}, ${primaryColor} 31%, #cccccc 49%, #cccccc)`,
  },
  linePagePayment: {
    backgroundImage: `linear-gradient(to right, ${primaryColor}, ${primaryColor} 57%, #cccccc 67%, #cccccc)`,
  },
  linePageConfirmation: {
    backgroundImage: `linear-gradient(to right, ${primaryColor}, ${primaryColor} 93%, #cccccc 99%, #cccccc)`,
  },
});
